// agriflow/customers/static/js/customers.js

import customersUpdate from './modules/customersUpdate'
import renderContact from './modules/renderContact'
import customersChangeHistory from './modules/customersChangeHistory'
import getNextNumerView from '../../../core/static/module/numberRange.js';
import customersCreate from './modules/customersCreate'
import CustomerImport from "./modules/importCustomers.js";
import titleCreate from "./modules/titleCreate";
import titleUpdate from './modules/titleUpdate';
import ArchiveManager from '../../../assets/js/common/ArchiveModal.js';

document.addEventListener('DOMContentLoaded', function () {
    const customerscreate = new customersCreate();
    const customersupdate = new customersUpdate();
    const rendercontact = new renderContact();
    const customerschangehistory = new customersChangeHistory();
    const titlecreate = new titleCreate();
    const titleupdate = new titleUpdate();


    const archiveBtn = document.getElementById('archiveBtn');
    if (archiveBtn) {
        const archiveManager = new ArchiveManager(archiveBtn);
        archiveBtn.addEventListener('click', () => {
            const url = archiveBtn.getAttribute('data-archive');
            archiveManager.toggleArchive(url);
        });
    }


    const uploadButton = document.getElementById('uploadButton');
    if (uploadButton) {
        uploadButton.addEventListener('click', (event) => {
            event.preventDefault();
            CustomerImport();
        });
    }

    if (typeof import_url !== 'undefined' && document.querySelector(".my-icon-class")) {
        const iconContainer = document.querySelector(".my-icon-class");
        const link = document.createElement("a");
        link.href = import_url;
        const icon = document.createElement("i");
        icon.classList.add("fa-solid", "fa-upload");
        link.appendChild(icon);
        iconContainer.appendChild(link);
    }


    const formObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.addedNodes.length) {
                const titelSelect = document.querySelector('#id_titel');
                const companyNameField = document.querySelector('#id_name');
                
                // Nur ausführen, wenn es ein SELECT ist (nicht im Contact-Modal)
                if (titelSelect && titelSelect.tagName === 'SELECT' && companyNameField) {
                    companyNameField.parentElement.parentElement.style.display = 'none';
                    
                    titelSelect.addEventListener('change', function() {
                        if (this.value === 'Firma') {
                            companyNameField.parentElement.parentElement.style.display = 'block';
                        } else {
                            companyNameField.parentElement.parentElement.style.display = 'none';
                        }
                    });
                }
            }
        });
    });
    
    formObserver.observe(document.body, {
        childList: true,
        subtree: true
    });
    
    const createCustomerForm = document.getElementById('customerCreate');
    if(!createCustomerForm) return;
    getNextNumerView('KUN');


});